import { AccessGate, useCan } from '../../shared/access/AccessControls';
import React from 'react';
import { Company } from '../../shared/types/company';
import CompanyForm from './CompanyForm';
import CompanyInfo from './CompanyInfo';
import Wrapper from '../../shared/components/Wrapper';
import { useEditMode } from '../../shared/hooks/useEditMode';
import EditModeSwitcher from '../../shared/components/EditModeSwitcher';

interface ICompanyData {
  company: Company;
}

const CompanyData: React.FC<ICompanyData> = ({ company }) => {
  const canEdit = useCan('ADMIN_COMPANY_UPDATE');
  const { edit, toggleEditMode, setEdit } = useEditMode();

  return (
    <Wrapper>
      <>
        <AccessGate action="ADMIN_COMPANY_UPDATE"><EditModeSwitcher toggleEditMode={toggleEditMode} edit={edit} /></AccessGate>
        {(edit && canEdit && <CompanyForm company={company} setEdit={setEdit} />) || (
          <CompanyInfo company={company} />
        )}
      </>
    </Wrapper>
  );
};

export default CompanyData;
